import React from 'react'

const SvgBullet = props => (
  <svg width="1em" height="1em" viewBox="0 0 18 24" {...props}>
    <g fill="none">
      <path
        fill="#fff"
        stroke="#0FC3C4"
        strokeWidth={2}
        d="M1 2.02v14.628l7 5.333V7.352L1 2.02z"
      />
      <path fill={props.fill} d="M18 0v17.143L9 24V6.857z" />
    </g>
  </svg>
)

export default SvgBullet
